export default __webpack_public_path__ + "static/media/resource-locker-featured-image-placeholder.fab7360e.svg";